import type { JSX } from "solid-js";
import "./Ghost.css";

type Props = {
	className?: string;
	width?: string | number;
	height?: string | number;
	rounded?: boolean;
	animate?: boolean;
	style?: JSX.CSSProperties;
};

export const Ghost = ({
	className,
	width,
	height,
	rounded = false,
	animate = true,
	style,
}: Props) => {
	const widthStyle = width
		? typeof width === "number"
			? `${width}px`
			: width
		: "100%";
	const heightStyle = height
		? typeof height === "number"
			? `${height}px`
			: height
		: "1rem";
	const styles = { width: widthStyle, height: heightStyle, ...(style ?? {}) };
	return (
		<div
			class={`gvtui-ghost ${rounded ? "rounded" : ""} ${className ? ` ${className}` : ""} ${animate ? "animate" : ""}`}
			style={styles}
		></div>
	);
};
